(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[907],{

/***/ 346:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features",
      function () {
        return __webpack_require__(9633);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9591);
/* harmony import */ var _insightfulscience_atomic_react_Hero_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1319);
/* harmony import */ var _insightfulscience_atomic_react_Hero_Description__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(410);
/* harmony import */ var _insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1192);
/* harmony import */ var _insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7478);
/* harmony import */ var _insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2989);
/* harmony import */ var _insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4229);
/* harmony import */ var _insightfulscience_atomic_react_r1_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2985);
/* harmony import */ var _insightfulscience_atomic_react_Hero_Grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6432);
/* harmony import */ var _insightfulscience_atomic_react_Hero_ButtonLink__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5765);
/* harmony import */ var _insightfulscience_atomic_react_PageNavbar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1794);
/* harmony import */ var _insightfulscience_atomic_react_PageNavbar_Item__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(361);
/* harmony import */ var _insightfulscience_atomic_react_PageNavbar_Link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4661);
/* harmony import */ var _insightfulscience_atomic_react_LandingElement_SimpleSectionStripped__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7045);
/* harmony import */ var _insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2866);
/* harmony import */ var _insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5185);
/* harmony import */ var _insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1041);
/* harmony import */ var _insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(6176);
/* harmony import */ var _insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8774);
/* harmony import */ var _insightfulscience_atomic_react_Line__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(5945);
/* harmony import */ var _insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(3890);
/* harmony import */ var _insightfulscience_smart_react_NextLink__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(5098);
/* harmony import */ var _insightfulscience_shared_utils_fn_create_and_raise__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(5161);
/* harmony import */ var _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(6651);
/* harmony import */ var _insightfulscience_smart_react_hocs_WithConditions__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(3803);
/* harmony import */ var _insightfulscience_i18__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(6003);
/* harmony import */ var _insightfulscience_shared_utils_fn_pipe__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(5833);
/* harmony import */ var _src_SiteLayout__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(3939);
/* harmony import */ var _src_TryForFree__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(7707);
/* harmony import */ var _src_routes__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(233);
/* harmony import */ var _src_routing_utils__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(1417);
/* harmony import */ var _src_services__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(329);
/* harmony import */ var _src_AppError_withErrorHandling__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(1802);
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(2109);
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_locales__WEBPACK_IMPORTED_MODULE_34__);




































const img1 = "/images/dotmatics/omiq/features/img-1.png";
const img2 = "/images/dotmatics/omiq/features/img-2.png";
const img3 = "/images/dotmatics/omiq/features/img-3.png";
const img4 = "/images/dotmatics/omiq/features/img-4.png";
const img5 = "/images/dotmatics/omiq/features/img-5.png";
const img6 = "/images/dotmatics/omiq/features/img-6.png";
const img7 = "/images/dotmatics/omiq/features/img-7.png";
const img8 = "/images/dotmatics/omiq/features/img-8.png";
const img9 = "/images/dotmatics/omiq/features/img-9.png";
const img10 = "/images/dotmatics/omiq/features/img-10.png";
const img11 = "/images/dotmatics/omiq/features/img-11.png";
const img12 = "/images/dotmatics/omiq/features/img-12.png";
const img13 = "/images/dotmatics/omiq/features/img-13.png";
const img14 = "/images/dotmatics/omiq/features/img-14.png";
const img15 = "/images/dotmatics/omiq/features/img-15.png";
const img16 = "/images/dotmatics/omiq/features/img-16.png";
const img17 = "/images/dotmatics/omiq/features/img-17.png";
const FeaturesPage = ()=>{
    const [t] = (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_26__/* .useLocale */ .bU)("feature-page");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_src_SiteLayout__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
                title: t("PAGE_TITLE"),
                description: t("META_DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_22__/* ["default"].OGP */ .ZP.OGP, {
                        title: t("PAGE_TITLE"),
                        description: t("META_DESCRIPTION")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Canonical */ .ZP.Canonical, {
                        href: t("META_CANONICAL")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                color: "6",
                className: "py-18",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_r1_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    lg: 11,
                    center: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            children: "Single Cell Analysis, Made Simple"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero_Description__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            children: "Complete your entire workflow in one software, from raw data to statistical significance, using familiar tools seamlessly blended with cutting-edge computational methods and visualizations."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Hero_Grid__WEBPACK_IMPORTED_MODULE_10__/* .HeroRow */ .P, {
                            className: "mt-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero_Grid__WEBPACK_IMPORTED_MODULE_10__/* .HeroCol */ .Z, {
                                    md: 3,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_NextLink__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        Component: _insightfulscience_atomic_react_Hero_ButtonLink__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
                                        href: _src_routes__WEBPACK_IMPORTED_MODULE_30__/* ["default"].freeTrial.url */ .Z.freeTrial.url,
                                        isBlock: true,
                                        styleType: "secondary",
                                        className: "section-hero__button",
                                        children: "Try for Free"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero_Grid__WEBPACK_IMPORTED_MODULE_10__/* .HeroCol */ .Z, {
                                    md: 3,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_NextLink__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        Component: _insightfulscience_atomic_react_Hero_ButtonLink__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
                                        href: _src_routes__WEBPACK_IMPORTED_MODULE_30__/* ["default"].pricing.url */ .Z.pricing.url,
                                        styleType: "secondary",
                                        isOutline2: true,
                                        className: "section-hero__button",
                                        isBlock: true,
                                        children: "Pricing"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_PageNavbar__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                alignHorizontal: "around",
                bgColor: "transparent",
                withBorder: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_PageNavbar_Item__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_PageNavbar_Link__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            href: "#high-dimensional-analysis",
                            children: "High Dimensional Analysis"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_PageNavbar_Item__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_PageNavbar_Link__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            href: "#classic-analysis",
                            children: "Classical Analysis"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_PageNavbar_Item__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_PageNavbar_Link__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            href: "#cloud-platform",
                            children: "Cloud Platform"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_PageNavbar_Item__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_PageNavbar_Link__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            href: "#autogating",
                            children: "Autogating"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_LandingElement_SimpleSectionStripped__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                id: "high-dimensional-analysis",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Title */ .Z.Title, {
                        children: "High-Dimensional Power"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"].DescriptionV2 */ .Z.DescriptionV2, {
                        children: "Use OMIQ's suite of machine learning tools to bring order to complex high-dimensional data."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Body */ .Z.Body, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            px: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    md: 5,
                                    indent: false,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                            children: "Dimensionality Reduction"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    children: "Run t-SNE, UMAP, PCA, EmbedSOM, FIt-SNE, TriMap, and more. Use opt-SNE to remove the guesswork with settings and get great results every time."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    children: "Take advantage of GPU-accelerated processing options to get results over 100x faster in some cases."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    src: img1,
                                    md: 7,
                                    isImageFrame: true
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isBorderNone: true,
                bgColor: "4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    px: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            src: img2,
                            md: 7,
                            isImageFrame: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            md: 5,
                            indent: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                    children: "Clustering"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: "Categorize data into populations automatically with FlowSOM, Phenograph, PARC, SPADE, ClusterX, and more."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: "Use graph analysis or heatmaps to deepen your understanding of stucture and patterns within data."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSectionStripped__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    px: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            md: 5,
                            indent: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                    children: "Statistical Differential Analysis"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        children: "Cut through the noise and find what matters. OMIQ has visualizations and statistical methods to find the strongest stratifying signals aligned with clinical or experimental metadata."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            src: img3,
                            md: 7,
                            isImageFrame: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isBorderNone: true,
                bgColor: "4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    px: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            src: img4,
                            md: 7,
                            isImageFrame: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            md: 5,
                            indent: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                    children: "Trajectory Inference"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        children: "Discover and visualize paths of cellular development. Understand differentation switch points and cell fate."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSectionStripped__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    px: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            md: 5,
                            indent: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                    children: "Automated Data Cleaning"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        children: "Everything starts with clean data. Incorporate algorithms such as flowAI and flowCut into your workflow to help automate and standardize this key step of analysis."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            src: img5,
                            md: 7,
                            isImageFrame: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isBorderNone: true,
                bgColor: "4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        px: false,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                src: img6,
                                md: 7,
                                isImageFrame: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                md: 5,
                                indent: false,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                        children: "Normalization"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: "Tame batch effects and other unwanted signal differences between files in order to improve comparability for analysis and visualization."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X2, {
                        className: "mt-26",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                            center: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_20__/* ["default"].Link */ .Z.Link, {
                                href: _src_routes__WEBPACK_IMPORTED_MODULE_30__/* ["default"].freeTrial.url */ .Z.freeTrial.url,
                                styleType: "secondary",
                                isOutline: true,
                                children: "Try OMIQ Free"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_LandingElement_SimpleSectionStripped__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                id: "classic-analysis",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X2, {
                        className: "mb-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    Tag: "h2",
                                    size: "xl",
                                    center: true,
                                    children: "Classical Analysis"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    size: "l",
                                    center: true,
                                    className: "mb-12",
                                    children: "OMIQ has you covered for your classic manual analysis needs"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        px: false,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                md: 5,
                                indent: false,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                        children: "Compensation and Scaling"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: "Convenient functionality for adjusting compensation and setting scales."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                src: img7,
                                md: 7,
                                isImageFrame: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isBorderNone: true,
                bgColor: "4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    px: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            src: img8,
                            md: 7,
                            isImageFrame: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            md: 5,
                            indent: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                    children: "Gating"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        children: "Interactive display boundaries for plots. Filter data down by gate or filter using subsampling."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSectionStripped__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    px: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            md: 5,
                            indent: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                    children: "Figures and Reporting"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        children: "Integrated figures and reporting allow you to achieve meaningful results faster."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            src: img9,
                            md: 7,
                            isImageFrame: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isBorderNone: true,
                bgColor: "4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        px: false,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                src: img10,
                                md: 7,
                                isImageFrame: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                md: 5,
                                indent: false,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                        children: "Export Results"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: "Export individual plots or batch reports from an OMIQ Figure. Multiple formats are available, such as PNG, SVG, PDF, and PPT."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X2, {
                        className: "mt-26",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                            center: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_20__/* ["default"].Link */ .Z.Link, {
                                href: _src_routes__WEBPACK_IMPORTED_MODULE_30__/* ["default"].freeTrial.url */ .Z.freeTrial.url,
                                styleType: "secondary",
                                isOutline: true,
                                children: "Try OMIQ Free"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_LandingElement_SimpleSectionStripped__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                id: "cloud-platform",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X2, {
                        className: "mb-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    Tag: "h2",
                                    size: "xl",
                                    center: true,
                                    children: "Modern Cloud Platform"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    size: "l",
                                    center: true,
                                    className: "mb-12",
                                    children: "Powerful, easy-to-use software that accelerates your journey from data to insights"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        px: false,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                md: 5,
                                indent: false,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                        children: "Share and Collaborate"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                children: "Choose permission levels and add colleagues with a click. Get to results faster, together."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                children: "Form connections, share datasets, share workflows, adjust roles and permissions and create easy to use groups for collaboration."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                src: img11,
                                md: 7,
                                isImageFrame: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isBorderNone: true,
                bgColor: "4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    px: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            src: img12,
                            md: 7,
                            isImageFrame: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            md: 5,
                            indent: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                    children: "Secure and Auditable"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: "Your data is safe with OMIQ's enterprise-grade security, including end-to-end and at-rest encryption, and organizational security-in-depth."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: "All analysis in OMIQ is stored as a traceable sequence of steps called a Workflow. Workflows can be locked for safekeeping."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSectionStripped__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    px: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            md: 5,
                            indent: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                    children: "Flexible Data Input"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        children: "FCS, CSV, LMD. Regardless of your input format, OMIQ will accept it. Clinical and experimental metadata can be cross-referenced manually or automatically to help OMIQ extract the insights that matter."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            src: img13,
                            md: 7,
                            isImageFrame: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isBorderNone: true,
                bgColor: "4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        px: false,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                src: img14,
                                md: 7,
                                isImageFrame: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                md: 5,
                                indent: false,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                        children: "Customizable Plugins and Scripts"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: "With plugins, your code can run inside OMIQ. Share your algorithms with the world or keep them private for your enterprise only."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X2, {
                        className: "mt-26",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                            center: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_20__/* ["default"].Link */ .Z.Link, {
                                href: _src_routes__WEBPACK_IMPORTED_MODULE_30__/* ["default"].freeTrial.url */ .Z.freeTrial.url,
                                styleType: "secondary",
                                isOutline: true,
                                children: "Try OMIQ Free"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_LandingElement_SimpleSectionStripped__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                id: "autogating",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X2, {
                        className: "mb-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    Tag: "h2",
                                    size: "xl",
                                    center: true,
                                    children: [
                                        "Autogating Services",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "ml-3 font-size--14 text-weight--bold text-color-2",
                                            children: "ADD-ON"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    size: "l",
                                    center: true,
                                    className: "mb-12",
                                    children: "Bespoke automated data analysis pipelines for cytometry data providing rapid, robust and reproducible results"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        px: false,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                md: 5,
                                indent: false,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                        children: "Automated Gating"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                children: "Automated gating pipelines are collaboratively customized for each client to robustly reproduce your existing gating hierarchy."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                children: "Once the pipeline is designed, our gates will adjust themselves for each sample using a robust, reproducible framework."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                src: img15,
                                md: 7,
                                isImageFrame: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isBorderNone: true,
                bgColor: "4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    px: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            src: img16,
                            md: 7,
                            isImageFrame: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            md: 5,
                            indent: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                    children: "Quality Checking"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        children: "With our automated approaches, the data QCs itself. We build the checks into the gating process to make sure FCS files are internally consistent, match with patient files, and that all the reportables that need to be filled out are done correctly."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        px: false,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                md: 5,
                                indent: false,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Title */ .Z.Title, {
                                        children: "OMIQ Integration"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Meta__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Description */ .Z.Description, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: "Reusable R pipeline integrates seamlessly into OMIQ. Produced gates are native OMIQ format. Built-in compliance with OMIQ with no IT involvement."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Feature_Image__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                src: img17,
                                md: 7,
                                isImageFrame: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X2, {
                        className: "mt-26",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                            center: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_20__/* ["default"].Link */ .Z.Link, {
                                href: _src_routes__WEBPACK_IMPORTED_MODULE_30__/* ["default"].external.help */ .Z.external.help,
                                styleType: "secondary",
                                isOutline: true,
                                children: "Contact Us"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Line__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isBorderNone: true,
                className: "mb-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X2, {
                        className: "mb-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    Tag: "h2",
                                    size: "xl",
                                    center: true,
                                    children: "OMIQ Features"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    size: "l",
                                    center: true,
                                    className: "mb-12",
                                    children: "Explore a list of OMIQ’s features and services"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X2, {
                        mx: true,
                        my: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                                md: 6,
                                className: "bordered-black-20 px-10 py-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        Tag: "h3",
                                        className: "mt-0",
                                        children: "Classic Analysis"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Adjust compensation"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Set scales"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Gating"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Make figures"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Visual batch reports"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Statistical batch reports"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                                md: 6,
                                className: "bordered-black-20 px-10 py-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        Tag: "h3",
                                        className: "mt-0",
                                        children: "Data Management"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Reproducible workflows"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Import fcs, csv and lmd files"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Customizable plugins"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Auditable and reproducible"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Enterprise grade security"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "GxP compliance"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Sharing and collaboration"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                                md: 6,
                                className: "bordered-black-20 px-10 py-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        Tag: "h3",
                                        className: "mt-0",
                                        children: "High Dimensional Analysis"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Dimensionality Reduction with t-SNE, UMAP, PCA, EmbedSOM, FIt-SNE, TriMap"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Clustering with FlowSOM, Phenograph, PARC, SPADE, Cluster"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Statistical differential analysis"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Trajectory interference"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Automated data cleaning with flowAI and flowCut"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Normalization"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                                md: 6,
                                className: "bordered-black-20 px-10 py-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        Tag: "h3",
                                        className: "mt-0",
                                        children: "Autogating"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Automated gating"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Biomarker discovery"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Quality checking"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Customized reports"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                                                children: "Reusable R pipeline"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_TryForFree__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {})
        ]
    });
};
FeaturesPage.preConditions = [
    [
        ()=>(0,_src_routing_utils__WEBPACK_IMPORTED_MODULE_31__/* .isRouteEnable */ .KT)(_src_routes__WEBPACK_IMPORTED_MODULE_30__/* ["default"].features */ .Z.features),
        (0,_insightfulscience_shared_utils_fn_create_and_raise__WEBPACK_IMPORTED_MODULE_35__/* .createAndRaise */ .C)(_insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_24__/* ["default"].NotFound */ .Z.NotFound)
    ]
];
/* harmony default export */ __webpack_exports__["default"] = ((0,_insightfulscience_shared_utils_fn_pipe__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(FeaturesPage, (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_26__/* .WithLocale */ ._t)({
    resources: (_locales__WEBPACK_IMPORTED_MODULE_34___default())
}), _insightfulscience_smart_react_hocs_WithConditions__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .ZP, _src_AppError_withErrorHandling__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, _src_services__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z));


/***/ }),

/***/ 6934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppError_AppError; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(6651);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(6965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(2866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(4229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(5522);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(233);
;// CONCATENATED MODULE: ./src/AppError/Error400.js






const Error400 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                level: 1,
                size: "xl",
                center: true,
                className: "mb-6 text-color-3",
                children: "Bad Request"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                size: "s",
                center: true,
                className: "",
                children: [
                    "We’re sorry, you didn’t provide all mandatory inputs or provided data was incorrect.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: routes/* default.external.help */.Z.external.help,
                        size: "s",
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/AppError/Error401.js







const Error401 = ()=>{
    const { asPath  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                level: 1,
                size: "xl",
                center: true,
                className: "mb-6 text-color-3",
                children: "Not Authorized"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                size: "s",
                center: true,
                className: "",
                children: [
                    "We’re sorry. You are not authorized to access the requested resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "".concat(routes/* default.auth.logout */.Z.auth.logout, "?returnUrl=").concat(encodeURIComponent(asPath)),
                        size: "s",
                        children: "sign in"
                    }),
                    " ",
                    "with a different account, or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: routes/* default.external.help */.Z.external.help,
                        size: "s",
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js






const Error403 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                level: 1,
                size: "xl",
                center: true,
                className: "mb-6 text-color-3",
                children: "Not Permitted"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                size: "s",
                center: true,
                className: "",
                children: [
                    "We’re sorry, you don’t have sufficient permissions to access this resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: routes/* default.external.help */.Z.external.help,
                        size: "s",
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error403 = (Error403);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageTitle/index.js
var PageTitle = __webpack_require__(3446);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 12 modules
var i18 = __webpack_require__(2771);
;// CONCATENATED MODULE: ./src/AppError/Error404.js






const Error404 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("app-error");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                title: t("404.META_TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                level: 1,
                size: "xl",
                center: true,
                className: "mb-6 text-color-1",
                children: t("404.TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                size: "s",
                center: true,
                children: t("404.DESCRIPTION")
            })
        ]
    });
};
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js








const Error500 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("app-error");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                title: t("500.META_TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                level: 1,
                size: "xl",
                center: true,
                className: "mb-6 text-color-1",
                children: t("500.TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                size: "s",
                center: true,
                className: "",
                children: [
                    t("500.DESCRIPTION"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("500.PARAGRAPH_1"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: routes/* default.external.help */.Z.external.help,
                        size: "s",
                        children: t("500.CONTACT_US")
                    }),
                    " ",
                    t("500.PARAGRAPH_2")
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error500 = (Error500);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(2985);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(9032);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js





const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "panel bg-color-black",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: " text-color-white px-5 py-5",
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = (config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? ErrorDetails : ()=>null);

// EXTERNAL MODULE: ./src/AppError/ErrorLayout.js
var ErrorLayout = __webpack_require__(9093);
// EXTERNAL MODULE: ./src/sentry.js + 69 modules
var sentry = __webpack_require__(1123);
;// CONCATENATED MODULE: ./src/AppError/AppError.js













const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404
};
const AppError = (param)=>{
    let { error , Layout =ErrorLayout/* default */.Z , ...props } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const error = ApplicationError/* default.of */.Z.of(err !== null && err !== void 0 ? err : {});
    if (res) {
        res.statusCode = error.code;
    }
    (0,sentry/* notifySentry */.Yw)(err, context);
    if (error.code >= 500 && error.originalError != null) throw error.originalError;
    return {
        error: error.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z,
    Layout: prop_types.elementType
};
/* harmony default export */ var AppError_AppError = (AppError);


/***/ }),

/***/ 9093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5449);
/* harmony import */ var _insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3512);
/* harmony import */ var _insightfulscience_atomic_react_utils_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8657);
/* harmony import */ var _SiteLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3939);







/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                shadow: false,
                bgColor: _insightfulscience_atomic_react_utils_color__WEBPACK_IMPORTED_MODULE_4__/* .bgColor4 */ .jh,
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "pt-9 pt-9--md pb-18 pb-18--md",
                children: extra
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node,
    extra: prop_types__WEBPACK_IMPORTED_MODULE_6__.node
};
/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode, isAuthorized: boolean }>} */ const ErrorLayoutPure = (param)=>/*#__PURE__*/ {
    let { children , extra , isAuthorized  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Pure */ .Z.Pure, {
        isAuthorized: isAuthorized,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                shadow: false,
                bgColor: _insightfulscience_atomic_react_utils_color__WEBPACK_IMPORTED_MODULE_4__/* .bgColor4 */ .jh,
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "pt-9 pt-9--md pb-18 pb-18--md",
                children: extra
            })
        ]
    });
};
ErrorLayoutPure.propTypes = {
    ...ErrorLayout.propTypes,
    isAuthorized: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool
};
ErrorLayout.Pure = ErrorLayoutPure;
/* harmony default export */ __webpack_exports__["Z"] = (ErrorLayout);


/***/ }),

/***/ 6965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 1802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(455);
/* harmony import */ var _AppError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6934);




const withErrorHandling = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        if (error == null) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            error: error
        });
    };
    Object.assign(WithErrorHandling, Component);
    WithErrorHandling.propTypes = _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes;
    WithErrorHandling.getInitialProps = (context, container)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context, container) : {};
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__/* .isPromise */ .tI)(props) ? props.catch((err)=>{
                return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                    ...context,
                    err
                }, container);
            }) : props;
        } catch (err) {
            return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                ...context,
                err
            }, container);
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ __webpack_exports__["Z"] = (withErrorHandling);


/***/ }),

/***/ 7707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TryForFree_TryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js + 1 modules
var SectionTryForFree = __webpack_require__(9334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/Link.js
var Link = __webpack_require__(5284);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 12 modules
var i18 = __webpack_require__(2771);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(233);
;// CONCATENATED MODULE: ./src/TryForFree/TryForFree.js






const TryForFree = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("common");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTryForFree/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTryForFree/* default.Title */.Z.Title, {
                children: "Experience the future of flow cytometry."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTryForFree/* default.Action */.Z.Action, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    styleType: "secondary",
                    href: routes/* default.freeTrial.url */.Z.freeTrial.url,
                    children: t("TRY_FOR_FREE")
                })
            })
        ]
    });
};
/* harmony default export */ var TryForFree_TryForFree = (TryForFree);

;// CONCATENATED MODULE: ./src/TryForFree/index.js



/***/ }),

/***/ 329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ services; },
  "T": function() { return /* binding */ serviceCore; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/NextPageWithServices.js
var NextPageWithServices = __webpack_require__(3200);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(9032);
// EXTERNAL MODULE: ./src/services/storage/index.js
var storage = __webpack_require__(6683);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/index.js + 2 modules
var gqlClient = __webpack_require__(7485);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/middlewares/index.js + 3 modules
var middlewares = __webpack_require__(2356);
;// CONCATENATED MODULE: ./src/services/gqlClient/index.js


const gqlClient_gqlClient = (param)=>{
    let { recoveryService: { shouldBeRecovered , recover  } , publicConfig: { GRAPHQL_URI , GRAPHQL_INTERNAL_URI  } , gqlEventsListener  } = param;
    return (0,gqlClient/* createGqlClient */.TV)({
        uri:  false ? 0 : GRAPHQL_URI
    }, (0,middlewares/* tap */.bw)(gqlEventsListener), (0,middlewares/* recovery */.sQ)(shouldBeRecovered, recover()), (0,middlewares/* batch */.dC)());
};
/* harmony default export */ var services_gqlClient = (gqlClient_gqlClient);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/operation.js + 1 modules
var gqlClient_operation = __webpack_require__(7687);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/GqlError.js
var GqlError = __webpack_require__(6870);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/jwt/jwtPayload.js
var jwtPayload = __webpack_require__(8644);
;// CONCATENATED MODULE: ./src/domain/token.js

/** @type {(token: { exp: number }) => boolean} */ const isNotExpired = (token)=>token && token.exp * 1000 > Date.now();
/** @type {(token: string) => boolean} */ const isTokenValid = (token)=>Boolean(token) && (0,jwtPayload/* jwtPayload */.q1)(token) != null;

;// CONCATENATED MODULE: ./src/services/recoveryService/refreshAccess.mutation.graphql
/* harmony default export */ var refreshAccess_mutation_graphql = ("mutation refreshAccess($refreshToken: String!) {\n  refreshAccess(refreshToken: $refreshToken) {\n    token\n    refreshToken\n  }\n}");
;// CONCATENATED MODULE: ./src/services/recoveryService/index.js




const isUnauthorized = (0,GqlError/* isExpectedGqlError */.ZO)(401);
const RecoveryService = (param)=>{
    let { storageService: { refreshToken , setTokens , clearAll  }  } = param;
    return {
        shouldBeRecovered: (err)=>isUnauthorized(err) && isTokenValid(refreshToken.read()),
        recover: ()=>{
            let recoveringPromise = null;
            return (context, operation, gqlClient)=>{
                recoveringPromise = recoveringPromise || gqlClient.last((0,gqlClient_operation/* Operation */.O)(refreshAccess_mutation_graphql, {
                    refreshToken: refreshToken.read()
                }), context).then((param)=>{
                    let { refreshAccess  } = param;
                    setTokens(refreshAccess);
                    recoveringPromise = null;
                }).catch((err)=>{
                    clearAll();
                    return Promise.reject(err);
                });
                return recoveringPromise;
            };
        }
    };
};
/* harmony default export */ var recoveryService = (RecoveryService);

// EXTERNAL MODULE: ./src/services/storageService/index.js
var storageService = __webpack_require__(8210);
;// CONCATENATED MODULE: ./src/services/subscriptionService/invoiceRequest.graphql
/* harmony default export */ var invoiceRequest_graphql = ("mutation invoiceRequest($invoiceItem: InvoiceItemInput!, $billingInfo:  BillingInfoInput!) {\n    invoiceRequest(invoiceItem: $invoiceItem, billingInfo: $billingInfo)\n}\n");
;// CONCATENATED MODULE: ./src/services/subscriptionService/index.js

const subscriptionService = (param)=>{
    let { gqlClient  } = param;
    const invoiceRequest = (param, turingToken)=>{
        let { invoiceItem , billingInfo  } = param;
        return gqlClient(invoiceRequest_graphql, {
            invoiceItem,
            billingInfo
        }, {
            headers: {
                "x-turing-token": turingToken
            }
        });
    };
    return {
        invoiceRequest
    };
};
/* harmony default export */ var services_subscriptionService = (subscriptionService);

;// CONCATENATED MODULE: ./src/services/routingService/index.js
const routingService = (param)=>{
    let { globalContext  } = param;
    return  false ? 0 : (__webpack_require__(8100)/* ["default"] */ .Z);
};
/* harmony default export */ var services_routingService = (routingService);

// EXTERNAL MODULE: ./src/services/storageService/token.js
var token = __webpack_require__(6381);
// EXTERNAL MODULE: ./src/services/storageService/refreshToken.js
var refreshToken = __webpack_require__(8596);
// EXTERNAL MODULE: ./src/services/storageService/priceItem.js
var priceItem = __webpack_require__(7632);
// EXTERNAL MODULE: ./src/services/storageService/billingInfo.js
var billingInfo = __webpack_require__(3083);
;// CONCATENATED MODULE: ./src/services/index.js












const serviceCore = {
    publicConfig: ()=>config/* publicConfig */.mn,
    storage: storage/* default */.Z,
    priceItem: priceItem/* priceItem */.x,
    billingInfo: billingInfo/* billingInfo */.A,
    token: token/* token */.r,
    refreshToken: refreshToken/* refreshToken */.g,
    storageService: storageService/* default */.Z,
    recoveryService: recoveryService,
    gqlClient: services_gqlClient,
    routingService: services_routingService,
    subscriptionService: services_subscriptionService
};
/* harmony default export */ var services = ((0,NextPageWithServices/* default */.Z)(serviceCore));


/***/ }),

/***/ 8100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

const push = next_router__WEBPACK_IMPORTED_MODULE_0___default().push.bind((next_router__WEBPACK_IMPORTED_MODULE_0___default()));
const replace = next_router__WEBPACK_IMPORTED_MODULE_0___default().replace.bind((next_router__WEBPACK_IMPORTED_MODULE_0___default()));
/* harmony default export */ __webpack_exports__["Z"] = ({
    push,
    replace
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [855,548,904,934,742,774,888,179], function() { return __webpack_exec__(7239), __webpack_exec__(346); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);